import {BaseFormLabelType} from "../../../Types";

export type FormLabelType = BaseFormLabelType & {
  mechanicalGroup: FormLabelMechanicalGroupEnum;
  mechanical: FormLabelMechanicalEnum;
  title: FormLabelTitleEnum | string;
  banner: FormLabelBannerEnum  | string;
  icon: string;
  capacity: string;
  discountLimit: [Date, Date] | null;
  oldPrice: string;
  discountPrecision: string;
};

export enum FormLabelMechanicalGroupEnum {
  BRI = 'BRI',
  LOT = 'LOT',
  SPECIAL = 'SPECIAL',
  RANGE = 'OFFRE SUR GAMME',
  BRAND = 'OFFRE SUR MARQUE',
  VOLUME = 'OFFRE SUR VOLUME',
}

export enum FormLabelMechanicalEnum {
  // BRI
  BRI_AMOUNT = "Remise en euro sur un produit",
  BRI_PERCENT = "Remise en pourcentage sur un produit",
  // LOT
  LOT_TWO_PLUS_ONE = "2+1",
  LOT_THREE_PLUS_ONE = "3+1",
  LOT_FOUR_PLUS_ONE = "4+1",
  // SPECIAL
  SPECIAL_ROUND = "Prix rond",
  SPECIAL_ALL_OFF_EURO = "Tout à (en euro)",
  SPECIAL_ALL_OFF_PERCENT = "Tout à (en pourcentage)",
  SPECIAL_GIFT = "Cadeau offert",
  // RANGE
  RANGE_AMOUNT = "Remise en euro sur une gamme",
  RANGE_PERCENT = "Remise en pourcentage sur une gamme",
  // BRAND
  BRAND_AMOUNT = "Remise en euro sur une marque",
  BRAND_PERCENT = "Remise en pourcentage sur une marque",
  // VOLUME
  VOLUME_IDENTICAL_PERCENT_SECOND_PRODUCT = "Remise en pourcentage sur un 2ème produit identique",
  VOLUME_IDENTICAL_PERCENT_THIRD_PRODUCT = "Remise en pourcentage sur un 3ème produit identique",
  VOLUME_DIFFERENT_PERCENT_SECOND_PRODUCT = "Remise en pourcentage sur un 2ème produit différent",
  VOLUME_DIFFERENT_PERCENT_THIRD_PRODUCT = "Remise en pourcentage sur un 3ème produit différent",
  VOLUME_SAME_RANGE_PERCENT_SECOND_PRODUCT = "Remise en pourcentage sur un 2ème produit de la même gamme",
  VOLUME_SAME_RANGE_PERCENT_THIRD_PRODUCT = "Remise en pourcentage sur un 3ème produit de la même gamme",
}

export enum FormLabelTitleEnum {
  DISCOUNT = "PROMOTION",
  IMMEDIATE_DISCOUNT = "REMISE IMMEDIATE",
  PRICE_DECREASE = "PRIX EN BAISSE",
  PRICE_ROUND = "PRIX ROND",
  UNBEATABLE = "IMBATTABLE",
  GIFT = "OFFRE CADEAU",
  BUY_TWO_GET_ONE_FREE = "2 ACHETÉS = 1 OFFERT",
  BUY_THREE_GET_ONE_FREE = "3 ACHETÉS = 1 OFFERT",
  BUY_FOUR_GET_ONE_FREE = "4 ACHETÉS = 1 OFFERT",
  DISCOUNT_OF_MONTH = "PROMO DU MOIS",
  OFFER_OF_MONTH = "OFFRE DU MOIS",
  OFFER_OF_SEASON = "OFFRE DE SAISON",
  ANTI_WASTE = "ANTI-GASPI",
}

export enum FormLabelBannerEnum {
  PRICE_DECREASE = "PRIX EN BAISSE",
  DISCOUNT_OF_MONTH = "PROMO DU MOIS",
}

export enum FormLabelDiscountDetailEnum {
  LIMIT = "Offre valable dans la limite des stocks disponibles",
}
